import { Component, Inject, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { SocialMediaAccount } from 'src/app/Models/SocialMediaAccountResponse';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { AppComponent } from 'src/app/app.component'; 
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-social-media-accounts',
  templateUrl: './social-media-accounts.component.html',
  styleUrls: ['./social-media-accounts.component.css']
})
export class SocialMediaAccountsComponent implements OnInit {
  displayedColumns: string[] = ['UserName','AccountId','Created_On','Ended_on','status','delete'];
  dataSource : any;
  SocialMediaAccountsData:SocialMediaAccount[]=[];
  CheckBusinessInfoId: string = "";
  UserId: string = "";
  getSafeValue(value:string | null):string{
    return (value=== null || value === "undefined") ? "" : value;
  }
  getImagePath(accountType: string): string {
    switch (accountType) {
      case 'Threads':
        return './assets/social_channel/threads.svg';
      case 'Facebook':
        return './assets/social_channel/facebook.svg';
      case 'Instagram':
        return './assets/social_channel/insta.svg';
      case 'X (Twitter)':
        return './assets/social_channel/twitter.svg';
      case 'LinkedIn':
        return './assets/social_channel/linkedin.svg';
      // Add more cases for additional account types if needed
      default:
        return ''; // Fallback image if no match
    }
  }

  constructor(public dialog: MatDialog, private toastr:ToastrService, public service:SharkifyAiSerivceService, public datepipe : DatePipe, public app: AppComponent, private readonly router: ActivatedRoute) { }

  ngOnInit(): void {
    this.UserId = this.getSafeValue(localStorage.getItem("UserId"));
    this.CheckBusinessInfoId=this.getSafeValue(localStorage.getItem("CheckBusinessInfoId"));
    
    this.app.displayLoader(true);
    const UserId=this.getSafeValue(localStorage.getItem("UserId"));
    this.router.queryParams.subscribe(params => {
      const connectType = params['connectType'];
      if (params?.['code']) {
        console.log(params?.['code']);
        this.service.createSocialMediaAccount(params?.['code'], UserId,  this.CheckBusinessInfoId, connectType).subscribe(accountinfo => {
          this.getSocialMediaAccounts();
        });
      }
    });
    this.getSocialMediaAccounts();

  }

  getSocialMediaAccounts() {
    this.service.ListOfSocialMediaAccounts(this.UserId,this.CheckBusinessInfoId).subscribe(data => {
        this.SocialMediaAccountsData = data.SocialMediaAccounts;
        this.dataSource = new MatTableDataSource(this.SocialMediaAccountsData);
        console.log(this.dataSource);
        this.SocialMediaAccountsData.forEach((element) => {
          element.CreatedOn = element.CreatedOn == null || element.CreatedOn == undefined ? "" : this.datepipe.transform(element.CreatedOn,"dd-MMM-yyyy")+ "";
         element.EndDate = element.EndDate == null || element.EndDate == undefined ? "" : this.datepipe.transform(element.EndDate,"dd-MMM-yyyy")+"";
        });

        this.app.displayLoader(false);
    });
  }

  ContentDialogBox(){
    let dailog_data ={
    }
    const dialogRef = this.dialog.open(contentchannel,{
        height:'auto',
        width:'911px',
        data:dailog_data,
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  DeleteAccount(id : any,name : any){
    let dialog_data ={
      accountid : id,
      userId : this.UserId,
      name : name,
    }
    const dialogRef = this.dialog.open(DeleteAccountDialog,{
        height:'auto',
        width:'350px',
        data:dialog_data,
    });
    dialogRef.afterClosed().subscribe(result => { 
      this.getSocialMediaAccounts();
    });
  }
}
@Component({
  selector : 'app-Content-channel',
  templateUrl : './app-Content-channel.html',
  styleUrls : ['./app-Content-channel.css'],
  encapsulation : ViewEncapsulation.None 
})
export class contentchannel {
  constructor(public dialogref: MatDialogRef<contentchannel>,private toastr: ToastrService,
    public service:SharkifyAiSerivceService,){}
  socialChannels = [
    {
      name: 'Threads',
      imgSrc: "./assets/social_channel/threads.svg",  // Replace with actual path to Threads icon
      learnMoreLink: '#'
    },
    {
      name: 'Facebook',
      imgSrc: "./assets/social_channel/facebook.svg",
      learnMoreLink: '#'
    },
    {
      name: 'Instagram',
      imgSrc: "./assets/social_channel/insta.svg",  // Replace with actual path to Instagram icon
      learnMoreLink: '#'
    },
    {
      name: 'X (Twitter)',
      imgSrc:  "./assets/social_channel/twitter.svg",  // Replace with actual path to Twitter icon
      learnMoreLink: '#'
    },
    {
      name: 'LinkedIn',
      imgSrc: "./assets/social_channel/linkedin.svg",  // Replace with actual path to LinkedIn icon
      learnMoreLink: '#'
    }
  ];
  openContentDialogBox(channel: any) {
    if (channel.name !== 'Instagram' && channel.name !== 'Facebook'  && channel.name !== 'LinkedIn') {
      const featureAvailable = false;
  
      if (!featureAvailable) {
        this.toastr.warning(
          'Feature in Progress: Coming soon in the next version!',
          'Coming Soon',
          {
            timeOut: 3000,
            progressBar: true,
            positionClass: 'toast-bottom-right',
          }
        );
        return;
      }
    }
  
    if (channel.name === 'Instagram')
    this.hanldeInstagramAccount();
  else if (channel.name === 'Facebook') {
    this.handleFacebookAccount();
  }
  else if (channel.name === 'LinkedIn') {
    this.handleLinkedInAccount();
  }
    // this.service.AddNewSocialMediaAccount("Sravan","Sravan@123","17","17","24","Instagram").subscribe(data => {
    //   if (data.Code == 200) {
    //   } else {
    //   }
    // });
  }
  hanldeInstagramAccount() {
    const redirectUrl = `${environment.INSTAGRAM_REDIRECT_URI}?connectType=instagram`;
    const url = `https://www.instagram.com/oauth/authorize?client_id=${environment.INSTAGRAM_CLIENT_ID}&redirect_uri=${redirectUrl}&response_type=code&scope=business_basic%2Cbusiness_manage_messages%2Cbusiness_manage_comments%2Cbusiness_content_publish`;

    window.location.href = url;
  }
  handleFacebookAccount() {
    const redirectUrl = `${environment.INSTAGRAM_REDIRECT_URI}?connectType=facebook`;
    console.log(redirectUrl);
    const url = `https://www.facebook.com/v22.0/dialog/oauth?client_id=1384795442330222&redirect_uri=${redirectUrl}&scope=public_profile,pages_manage_posts,pages_show_list`;

    window.location.href = url;
  }

  handleLinkedInAccount() {
    const redirectUrl = `${environment.INSTAGRAM_REDIRECT_URI}?connectType=linkedin`;
    console.log(redirectUrl);
    const url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=778o4oc0d2844j&redirect_uri=${redirectUrl}&state=foobar&scope=liteprofile%20emailaddress%20w_member_social`;

    window.location.href = url;
  }
  private showError(message: string): void {
    this.toastr.error(message, 'Error', {
      timeOut: 3000, 
      progressBar: true,  
      positionClass: 'toast-bottom-right' 
    });
  }
  closeDialog() {
    this.dialogref.close()
  }

}
@Component({
  selector : 'app-remove-account-dialog',
  templateUrl : './remove-account-dialog.html',
  styleUrls : ['./remove-account-dialog.css'],
  encapsulation : ViewEncapsulation.None 
})
export class DeleteAccountDialog{  
  constructor(public dialogref: MatDialogRef<DeleteAccountDialog>,private toastr: ToastrService,public service:SharkifyAiSerivceService, @Inject(MAT_DIALOG_DATA) public data: any){}
    ngOnInit(): void {
    }
    ConfirmDelete(){
      this.service.DeleteSocialMediaAccount(this.data.accountid+"",this.data.userId+"").subscribe(DATA => {
        if(DATA.Code == 200){
          this.toastr.success("your social media Acoount got deleted");
          this.closeAccountDialog();
        }else{
          this.toastr.error("Something went wrong");
        }
      });
    }
    closeAccountDialog() {
      this.dialogref.close()
    }
}